/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";

class PipelineSearchSlogan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.screenRatio = 1;
    if (typeof window !== 'undefined') {
      this.screenRatio = document.body.clientWidth / 375;
    }
  }

  componentDidMount() {}

  handleItemClick = (link) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link,
        props: this.props,
      })
      return
    }
    if (!link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link,
      type: baseConfig.sortType,
    };

    const convertUrl = utils.convertHref(link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,link, options, -1,this.props,false, {
      bizExtra: {
        href: convertUrl,
        title: baseConfig.title,
      }
    });

  }

  render() {
    const { baseConfig } = this.props.config;
    let moreText = baseConfig.moreText || '';
    if (moreText.length > 4) {
      moreText = moreText.slice(0, 4);
    }
    return (
      <div
        className="pipeline-search-slogan"
        {...this.props['customAttributes']}
        onClick={this.handleItemClick.bind(this, baseConfig.moreUrl)}
        style={{
          marginTop: px2rem('12px', false),
          marginBottom: px2rem('9px', false),
          marginLeft: px2rem('12px', false),
          marginRight: px2rem('12px', false),
          height: px2rem('36px', false),
        }}
      >
        <img className="logo-title" src={utils.formatImgUrl(baseConfig.titleImg, this.props.webpSupport)} style={{ width: px2rem('36px', false), height: px2rem('36px', false), borderRadius: '2px' }} alt="" />
        <div className="title-content" style={{ width: px2rem('190px', false), paddingLeft: px2rem('8px', false), paddingRight: px2rem('20px', false) }}>
          {
            baseConfig.title && 
              <div className="title-1" style={{ height: px2rem('22px', false), fontSize: px2rem('16px', false), lineHeight: px2rem('22px', false) }}>{baseConfig.title}</div>
          }
          {
            baseConfig.subTitle &&
              <div className="title-2" style={{ height: px2rem('12px', false), fontSize: px2rem('10px', false), lineHeight: px2rem('12px', false), }}>{baseConfig.subTitle}</div>
          }
        </div>
        <div className='more-link absolute' style={{ height: px2rem('18px', false) }}>
          <div className="more-text" style={{ height: px2rem('18px', false), fontSize: px2rem('13px', false) }}>{moreText}</div>
          <svg className="more-icon" t="1769417691178" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4067" width="12" height="12"><path d="M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z" p-id="4068" fill="var(--subtitle-color)"></path></svg>
        </div>
      </div>
    );
  }
}

PipelineSearchSlogan.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSearchSlogan };
export default PipelineSearchSlogan;



// WEBPACK FOOTER //
// ./components/pipeline-searchSlogan/index.js